import { pathNames } from "@/lib/constants/pathNames.constants";
import { filterCategories } from "@/lib/constants/search.constants";
import type { Hit } from "instantsearch.js";
import { isAbsoluteUrl } from "./common.utils";

/* Algolia returns all matched Hits based on what the user typed. The results are not filtered by category.
   This method maps through the results and filters them by type, returning an array of object with the number of results for a specific category.
   At first it takes an initial array of objects with all the categories and the counter being set to 0. Based on the hits returned it is updating that counter.
*/

export function getFilterCategories(hits: Hit[]) {
	const typeCounts: Record<string, number> = hits.reduce(
		(acc: Record<string, number>, obj) => {
			if (acc[obj.type]) {
				acc[obj.type]++;
			} else {
				acc[obj.type] = 1;
			}

			return acc;
		},
		{}
	);

	const filteredResults = filterCategories.map((category) => {
		const updatedFilterCategories = { ...category };

		Object.keys(typeCounts).forEach((type) => {
			if (category.id === type) {
				updatedFilterCategories.nrResults = typeCounts[type];
			}
		});

		return updatedFilterCategories;
	});

	return filteredResults;
}

/* This method is used for adding the base path name for each result's URL. 
   For events it is also checking if it is an internal event or not and based on that it will add the base path or just return the URL from the request .
   For drivers it is just returning the URL since all of them have absolute paths.
*/

export function getResultsUrl(hit: Hit) {
	switch (hit.type) {
		case filterCategories[0].id:
			return hit.url;

		case filterCategories[1].id:
			return isAbsoluteUrl(hit.url as string)
				? hit.url
				: pathNames.eventsDetails.replace("{event}", hit.url as string);

		case filterCategories[2].id:
			return pathNames.solutionDetails.replace("{solution}", hit.url as string);

		case filterCategories[3].id:
			return pathNames.pagesDetails.replace("{page}", hit.url as string);

		default:
			break;
	}
}
